import { ApiHandler } from '../ApiHandler'

export interface UserPublicKey {
  user_id: number
  public_key: string
  algo: string
  /** Что умеет устройство с этим ключом, например «secret_calls». */
  capabilities?: string[]
}

/**
 * E2E key + secret-chat endpoints. Only PUBLIC keys ever transit — the private
 * key stays in this device's IndexedDB (see shared/crypto/keyStore).
 */
export abstract class E2EKeyApi {
  /** Upload this device's public identity key (upsert, latest device wins). */
  public static async putMyKey(
    publicKey: string,
    capabilities: string[] = [],
  ): Promise<{ public_key: string; algo: string; capabilities?: string[] }> {
    return await ApiHandler.put('me/e2e-key', {
      public_key: publicKey,
      algo: 'x25519-xsalsa20-poly1305',
      capabilities,
    })
  }

  /** Fetch a user's current public key. Returns null when they have no E2E key yet. */
  public static async getUserKey(userId: number): Promise<UserPublicKey | null> {
    try {
      return await ApiHandler.get(`users/${userId}/e2e-key`)
    } catch {
      return null
    }
  }

  /** Create (or return existing) 1-on-1 secret E2E chat with the given user. */
  public static async createSecretChat(userId: number): Promise<any> {
    return await ApiHandler.post('chats/secret', { user_id: userId })
  }
}
